export const LONG_TERM_LINK_TITLE = 'Длительная аренда';
export const DAILY_LINK_TITLE = 'Посуточно';
export const DEAL_RENT_LINK_TITLE = 'Сдай / Сними на Циан';
export const DOM_RF_TITLE = 'Аренда квартир от ДОМ.РФ';
export const SECONDARY_LINK_TITLE = 'Квартиры';
export const JK_FLAT_LINK_TITLE = 'Квартиры в новостройках';
export const COTTAGE_LINK_TITLE = 'Дома';
export const BUILDER_PROMO_LINK_TITLE = 'Сколько стоит построить дом';
export const JKS_LINK_TITLE = 'Жилые комплексы';
export const KP_LINK_TITLE = 'Коттеджные поселки';
export const BC_LINK_TITLE = 'Бизнес-центры';
export const SC_LINK_TITLE = 'Торговые центры';
export const WC_LINK_TITLE = 'Складские комплексы';
